import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'È adatto a bambini piccoli?',
    a: 'Sì, il materiale è pensato per bambini dai 3 ai 12 anni.'
  }, {
    q: 'Le ricette sono difficili?',
    a: 'No. Sono pensate per famiglie reali e per mamme impegnate.'
  }, {
    q: 'Gli ingredienti sono facili da trovare?',
    a: 'Sì. Tutte le ricette utilizzano ingredienti reperibili nei supermercati italiani.'
  }, {
    q: 'Riceverò il materiale subito?',
    a: "Sì. L'accesso è immediato dopo l'acquisto."
  }, {
    q: 'Posso stampare il materiale?',
    a: 'Assolutamente sì.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(null);
  return <section className="bg-gray-50 py-20 px-4" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1f2e10] text-center mb-12" data-id="element-45">
          DOMANDE FREQUENTI
        </h2>

        <div className="space-y-4" data-id="element-46">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-47">
              <button onClick={() => setOpenIdx(openIdx === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-48">
                <span className="font-bold text-lg text-[#1f2e10] pr-4" data-id="element-49">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIdx === idx ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-50">
                  <ChevronDown className="text-green-600 flex-shrink-0" size={24} data-id="element-51" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-52">
                {openIdx === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-53">
                    <div className="px-6 pb-5 text-gray-600 text-lg border-t border-gray-100 pt-4 font-medium" data-id="element-54">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}